export const itemHaveViwer = (extension: string) => {
    if(extension !="pdf" && extension !="dwg" && extension !="png" &&extension !="jpg" && extension!="gif" && extension!="svg"&& 
        extension!="bmp" && extension!="webp" && extension!="docx" && extension!="doc" && extension!="dwg" && 
        extension != "xlsx" && extension != "ppt" && extension != "pptx" && extension != "mpp" && extension != "xls")
    {
        return false
    } else {
        return true
    }
}